// 服务公司
export const serviceCompany = [
  { value: 'beijingOverseas', label: '北京海外事业部' },
  { value: 'guangzhouOverseas', label: '广州海外事业部' },
  { value: 'shenzhenOverseas', label: '深圳海外事业部' },
  { value: 'hangzhouOverseas', label: '杭州海外事业部' },
  { value: 'overseasGroup', label: '海外事业群' },
]
// 杭州海外事业部收款账户
const hangzhouOverseas = [
  { value: 'zhaoshang-basic', label: '招商基本户' },
  { value: 'zhaoshang-fc', label: '招商外币' },
  { value: 'alipay', label: '支付宝' },
  { value: 'p-card-eur', label: 'p卡-欧元' },
  { value: 'p-card-usd', label: 'p卡-美元' },
  { value: 'p-card-gbp', label: 'p卡-英镑' },
  { value: 'zhaoshang-qrcode', label: '招商二维码' },
  { value: 'other', label: '其他' },
]

// 广州海外事业部收款账户
const guangzhouOverseas = [
  { value: 'gongshang-basic', label: '工商基本户' },
  { value: 'zhaoshang-general', label: '招商一般户' },
  { value: 'gongshang--fc-usd', label: '工商外币户-美元' },
  { value: 'gongshang--fc-eur', label: '工商外币户-欧元' },
  { value: 'gongshang--fc-gbp', label: '工商外币户-英镑' },
  { value: 'alipay', label: '支付宝' },
  { value: 'p-card-eur', label: 'p卡-欧元' },
  { value: 'p-card-usd', label: 'p卡-美元' },
  { value: 'p-card-gbp', label: 'p卡-英镑' },
  { value: 'zhaoshang-qrcode', label: '招商二维码' },
  { value: 'other', label: '其他' },
]

// 深圳海外事业部收款账户
const shenzhenOverseas = [
  { value: 'zhongxin-basic', label: '中信基本户' },
  { value: 'zhaoshang-general', label: '招商一般户' },
  { value: 'zhongxin-fc', label: '中信外币户' },
  { value: 'alipay', label: '支付宝' },
  { value: 'p-card-eur', label: 'p卡-欧元' },
  { value: 'p-card-usd', label: 'p卡-美元' },
  { value: 'p-card-gbp', label: 'p卡-英镑' },
  { value: 'zhaoshang-qrcode', label: '招商二维码' },
  { value: 'other', label: '其他' },
]
// 北京海外事业部收款账户
const beijingPaymentAccount = [
  { value: 'other', label: '其他' },
]


// 海外事业群收款账户
const overseasGroup = [
  { value: 'zhongxin-basic', label: '中信基本户' },
  { value: 'zhaoshang-general', label: '招商一般户' },
  { value: 'zhongxin-general', label: '中信一般户' },
  { value: 'zhongxin-fc', label: '中信外币户' },
  { value: 'ABO-trust-eur-local', label: 'ABO-trust欧元本地' },
  { value: 'ABO-trust-eur-overseas', label: 'ABO-trust欧元国际' },
  { value: 'ABO-trust-usd', label: 'ABO-trust美元' },
  { value: 'ABO-trust-gbp', label: 'ABO-trust英镑' },
  { value: 'alipay', label: '支付宝' },
  { value: 'p-card-eur', label: 'p卡-欧元' },
  { value: 'p-card-usd', label: 'p卡-美元' },
  { value: 'p-card-gbp', label: 'p卡-英镑' },
  { value: 'zhaoshang-qrcode', label: '招商二维码' },
  { value: 'other', label: '其他' },
]
// 收款账户
export const paymentAccount = {
  beijingOverseas: beijingPaymentAccount,
  guangzhouOverseas: guangzhouOverseas,
  shenzhenOverseas: shenzhenOverseas,
  hangzhouOverseas: hangzhouOverseas,
  overseasGroup: overseasGroup,
}

// 换汇币种options
export const currencyOptions = [
  {
    code: 'USD',
    value: '美元'
  },
  {
    code: 'GBP',
    value: '英镑'
  }, {
    code: 'JPY',
    value: '日元'
  }, {
    code: 'EUR',
    value: '欧元'
  }, {
    code: 'CNY',
    value: '人民币'
  }, {
    code: 'HKD',
    value: '港币'
  },
]



// WEBPACK FOOTER //
// ./src/components/productService/financialManagement/options.js